import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@material-ui/core/styles";
import { dangerColor, warningColor, infoColor } from "assets/jss/material-dashboard-pro-react.js";

// Enum espelhado de api/Models/Matriz/Comunicado.cs
const TipoComunicado = {
    AvisoSistema: 1,
    InformativoUnidade: 2,
    Alerta: 3,
};

const badge = (color) => ({
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: 500,
    color: "#fff",
    backgroundColor: color,
    whiteSpace: "nowrap"
});

// Mesmas cores da gestao do mural na Matriz (ComunicadoList)
const useStyles = makeStyles({
    alerta: badge(dangerColor[0]),
    aviso: badge(warningColor[0]),
    informativo: badge(infoColor[0])
});

export default function TipoComunicadoBadge({ tipo }) {
    const { t } = useTranslation();
    const classes = useStyles();

    switch (tipo) {
        case TipoComunicado.AvisoSistema:
            return <span className={classes.aviso}>{t('notice_board.type_system_notice')}</span>;
        case TipoComunicado.InformativoUnidade:
            return <span className={classes.informativo}>{t('notice_board.type_unit_information')}</span>;
        case TipoComunicado.Alerta:
            return <span className={classes.alerta}>{t('notice_board.type_alert')}</span>;
        default:
            return null;
    }
}
